export default "__VITE_ASSET__DfB8e23Z__"